import { StripeAPI } from '../api';
import { LOG, display_message_to_user } from '@phi/logging/frontend';
import { open_in_new_tab } from '@phi/util/window';
import state from '@frontend/state';

export const open_stripe_store_factory = (api: StripeAPI) => async () => {
    state.spinner = 'Please wait...';
    const url = await api.get_customer_portal_url();
    if (url instanceof Error) {
        console.error(url);
        display_message_to_user(LOG.ERROR, url.message);
    } else {
        open_in_new_tab(url);
    }
    state.spinner = undefined;
};
